import { Location } from "history";
import React, { useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';
//!!r-18-dj
//@ts-ignore
import { useHistory } from 'react-router';
import Dialog from "../../utilities/Dialog";

interface IProps {
    /** When set to true it will prevent leaving a page */
    when?: boolean | undefined;
    /** Message to show when preventing leave */
    message: string;
    // could add custom prop for custom checks
        // Example : <LeaveRouteGuard check={() => { random checks }} ...rest />
        // place callback in handleBlockNavigation if condition
}

// --------------------
// Original Reference : https://medium.com/@michaelchan_13570/using-react-router-v4-prompt-with-custom-modal-component-ca839f5faf39 
// --------------------

const RouteLeavingGuard = ({
    when,
    message
}: IProps) => {
    const [lastLocation, setLastLocation] = useState<Location | null>(null);
    const [confirmedNavigation, setConfirmedNavigation] = useState(false);
    let history: any = useHistory();

    const handleBlockedNavigation = (nextLocation: Location) => {
        if (!confirmedNavigation) {
            setLastLocation(nextLocation);
            setupAlert();
            return false;
        }else{
            return true
        }
    };

    const setupAlert = async () => {
        // Renders alert to screen and sets confirmed navigation to users response
        let dialog: any = new Dialog({ message });
        let answer: boolean = await dialog.show();
        setConfirmedNavigation(answer);
    }

    useEffect(() => {
        //console.log(confirmedNavigation, lastLocation)
        if (confirmedNavigation && lastLocation) {
            // Navigate to the previous blocked location with your navigate function
            history.push(lastLocation.pathname)
        }
    }, [confirmedNavigation, lastLocation, history]);

    return <Prompt when={when} message={handleBlockedNavigation as any} />;
};
export default RouteLeavingGuard;